/**
 * This method will convert all the values within the objects in the array to string
 * @param {} arrayObject
 * @returns
 */

export const stringifyArrayObjectValues = (arrayObject) => {
  const newArray = arrayObject.map((item) => {
    const newItem = { ...item };
    for (const key in newItem) {
      if (typeof newItem[key] === "object") {
        newItem[key] = JSON.stringify(newItem[key]);
      }
    }
    return newItem;
  });
  return newArray;
};

export const parseArrayObjectValues = (arrayObject) => {
  const newArray = arrayObject.map((item) => {
    let newItem = { ...item };
    for (const key in newItem) {
      try {
        newItem[key] = JSON.parse(newItem[key]);
      } catch (error) {
        newItem[key] = newItem[key]; // Assign the original string if it's not valid JSON
      }
    }
    return newItem;
  });
  return newArray;
};

export const isJsonString = (str) => {
  try {
    JSON.parse(str);
  } catch (e) {
    return false;
  }
  return true;
};

const maxLength = 32766;

export const removeBase64Images = (json) => {
  // Ensure json is an array
  if (Array.isArray(json)) {
    // Function to clean base64 <img> tags from all string properties
    return json.map((obj) =>
      Object.fromEntries(
        Object.entries(obj).map(([key, value]) => {
          let replaceValue =
            typeof value === "string"
              ? value.replace(/<img\s+src="data:image\/[^"]+"\s*\/?>/g, "")
              : value;
          return [
            key,
            replaceValue?.length > maxLength
              ? replaceValue?.slice(0, maxLength)
              : replaceValue,
          ];
        })
      )
    );
  } else {
    return json;
  }
};
